module.exports = __webpack_public_path__ + "static/media/rune-locked.e611b268.png";